import React, { useRef } from "react";
import ContactCSS from "./CSS/Contact.module.css";
import Heading from "../../components/Heading/Heading";
import { EmailIcon, PhoneIcon, WarningIcon } from "@chakra-ui/icons";
import {
  FaMapMarkerAlt,
  FaLocationArrow,
  FaGithub,
  FaLinkedin,
  FaPrayingHands
} from "react-icons/fa";
import { BiLinkExternal } from "react-icons/bi";
import { useToast } from '@chakra-ui/react'
import emailjs from "@emailjs/browser";

export default function Contact() {
  const toast = useToast()
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_cw8mdul",
        "template_4ioky4d",
        form.current,
        "us1ppCQaT95Q3_Zk6"
      )
      .then(
        (result) => {
          console.log(result.text);
          toast({
            title: 'Massage sent successfully!',
            description: `Thank you for contacting 🙏`,
            status: 'success',
            duration: 3000,
            isClosable: true,
          })
        },
        (error) => {
          console.log(error.text);
        }
      );
    document.contact_form.reset();
  };

  return (
    <>
      <div className={ContactCSS.container} id="contact">
        <div className={ContactCSS.ContactPage}>
          <Heading heading="Contact" after="Me" />

          <div className={ContactCSS.content}>
            <div className={ContactCSS.contactInfo}>
              <h1>
                <span style={{ color: "#FCC72A" }}>CONTACT</span> INFO
              </h1>

              <ul>
                <li>
                  <span style={{ color: "#E2AE1B" }}>
                    <FaLinkedin />
                  </span>{" "}
                  <span>
                    <a
                      href="https://www.linkedin.com/in/bikram-dutta-6a482523a/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Linkedin
                      <BiLinkExternal className={ContactCSS.links} />
                    </a>
                  </span>
                </li>
                <li>
                  <span style={{ color: "#E2AE1B" }}>
                    <FaGithub />
                  </span>{" "}
                  <span>
                    <a
                      href="https://github.com/bikramboss8055"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Github
                      <BiLinkExternal className={ContactCSS.links} />
                    </a>
                  </span>
                </li>
                <li>
                  <span style={{ color: "#E2AE1B" }}>
                    <EmailIcon />
                  </span>{" "}
                  <span>duttabikram260@gmail.com</span>
                </li>
                <li>
                  <span style={{ color: "#E2AE1B" }}>
                    <PhoneIcon />
                  </span>{" "}
                  <span>+91 8670578073</span>
                </li>
                <li>
                  <span style={{ color: "#E2AE1B" }}>
                    <FaMapMarkerAlt />
                  </span>{" "}
                  <span>Raniganj, West Bengal, India</span>
                </li>
              </ul>
            </div>
            <div>
              <form
                ref={form}
                name="contact_form"
                onSubmit={sendEmail}
                className={ContactCSS.emailForm}
              >
                <input
                  type="text"
                  name="user_name"
                  id="name"
                  placeholder="Name"
                />

                <input
                  type="email"
                  name="user_email"
                  id="email"
                  placeholder="Email"
                />

                <textarea name="message" id="message" placeholder="Message" />

                <button type="submit" className={ContactCSS.send}>
                  Send <FaLocationArrow />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
